export default __webpack_public_path__ + "locales/ar-SA/Payments.json?hash=ab14ddf3826dc85e4a016ec046b7a6c7";